/**
 * Search for a specific item inside a specific set of items.
 * This array could contain filters or loops too, so we create another function to search it recursively.
 *
 * @param {Array} items - The `UncannyAutomator._recipe.actions` items.
 * @param {Number} itemID - The item ID.
 * @return {Object|undefined} The item or `undefined`, if not found.
 */
const searchDepthItem = ( items, itemID ) => {
	// Search the item inside the first layer of items
	return items.reduce( ( previousSearch, item ) => {
		// If we already found an item in the previous iteration, just return that one
		if ( previousSearch ) {
			return previousSearch;
		}

		// If the item type and the ID match, return the item
		if ( item.id === itemID ) {
			return item;
		}

		// Specifically handle 'filter' type items to search in 'conditions'
		if ( item.type === 'filter' && Array.isArray( item.conditions ) ) {
			const foundInConditions = searchDepthItem(
				item.conditions,
				itemID
			);

			if ( foundInConditions ) {
				return foundInConditions;
			}
		}

		// Specifically handle 'loop' type items to search in 'filters'
		if ( item.type === 'loop' && Array.isArray( item.filters ) ) {
			const foundInConditions = searchDepthItem(
				item.filters,
				itemID
			);

			if ( foundInConditions ) {
				return foundInConditions;
			}
		}

		// Check if it has items inside
		if ( Array.isArray( item.items ) ) {
			return searchDepthItem(
				item.items,
				itemID
			);
		}

		return;
	// eslint-disable-next-line no-undefined
	}, undefined );
};

export default searchDepthItem;
